import { useCallback } from 'react';
import { FormApi } from 'final-form';

import { OnChange } from '@occc-app/design-system';

type EitherActivationOrAwardCountProps = {
  form: FormApi<any>;
};

export const EitherActivationOrAwardCount = ({ form }: EitherActivationOrAwardCountProps) => {
  const handleActivationIsEnabledOnChange = useCallback(
    (value: boolean) => {
      if (value) {
        form.mutators.setFieldValue('awardCount.isEnabled', false);
      }
    },
    [form.mutators],
  );
  const handleAwardCountIsEnabledOnChange = useCallback(
    (value: boolean) => {
      if (value) {
        form.mutators.setFieldValue('activation.isEnabled', false);
      }
    },
    [form.mutators],
  );
  return (
    <>
      <OnChange name='activation.isEnabled'>{handleActivationIsEnabledOnChange}</OnChange>
      <OnChange name='awardCount.isEnabled'>{handleAwardCountIsEnabledOnChange}</OnChange>
    </>
  );
};
